const response =  {
    "status": 200,
    "message": "OK",
    "data": [
        {
            "id": 1,
            "title": "Frontend Mentor",
            "location": "Dicoding Indonesia",
            "date": "Sep 2020",
            "desc": "Been a mentor or facilitator in the MPWA dicoding class, during the Baparekraf Digital Talent 2020 event",
        },
        {
            "id": 2,
            "title": "Backend Mentor",
            "location": "Dicoding Indonesia",
            "date": "Jun 2021",
            "desc": "Been a mentor or facilitator in the Backend for Beginner dicoding class, during the AWS Cloud and Backend Schoolarship 2021 event",
        },
        {
            "id": 3,
            "title": "Frontend & Backend Engineer ",
            "location": "PT. Solusi Intek Indonesia",
            "date": "Apr 2021 - Sep 2021",
            "desc": "Internship at a cyber technology base company as a frontend and backend web engineer",
        },
        {
            "id": 4,
            "title": "Backend Engineer",
            "location": "PT. Indonesia Hakiki Pertama",
            "date": "Oct 2021 - Present",
            "desc": "Work as backend engineer, deploy on cloud servers and API providers along with their web dashboards",
        },
    ]
}

export default response;